import React, { FC, ReactElement, useContext } from 'react'
import { ModalType, Plan } from '../../types/types'
import parse from 'html-react-parser';
import { Button } from '../../atoms/Button';
import './CardPlan.css'
import { AppGeneralContext } from '../../../shared/GeneralContext/GeneralContext';
import { postSwitchPlan } from 'api/Api';

interface iCardPlan {
    plan: Plan
}

export const CardPlan = ({ plan }: iCardPlan) => {

    const { startUp, setLoadingModal, setErrorModal, setModal } = useContext(AppGeneralContext)
    const switchPlan = (data: string, newPlan: string) => {
        setLoadingModal()
        postSwitchPlan({ data }).then((res) => {

            if (!res.isSuccess || !res.response) {
                setErrorModal(res.error)
                return false
            }
            setModal({ isOpen: true, type: ModalType.info, title: "Switch plan", message: `Your request to change your plan to ${newPlan} has been submitted!` })
        })
    }

    const isYearly = !!plan.yearPrice;
    const price = isYearly ? plan.yearPrice : plan.monthPrice
    const discountedPrice = isYearly ? plan.yearDiscountedPrice : plan.discountedPrice

    return (
        <div className='card-plan h-100'>
            <div className='d-flex flex-column justify-content-between h-100'>
                <div className='card-plan-title'>
                    <h3 className='pt-3 pb-3'>{plan?.title}</h3>
                </div>

                <div className='card-plan-body p-5'>
                    <div className='d-flex justify-content-center'>
                        {!!discountedPrice && discountedPrice > 0 ?
                            <span className='discounted-price d-flex align-items-end me-3'>
                                <span className='text-black'>€</span> {price}
                            </span> : null
                        }
                        <div className='current-price d-flex align-items-end'>
                            <h2 className='m-0 p-0'>€{!!discountedPrice ? discountedPrice : price}</h2>
                        </div>
                    </div>
                    <p className='text-center'>per {isYearly ? 'year' : 'month'}</p>

                    <div className='htmlDescription'>
                        {parse(plan?.htmlDescription ?? "")}
                    </div>
                </div>

                <div className='d-flex justify-content-center w-100 mt-3 pb-4'>
                    {startUp?.currentPlan?.id === plan.id ?
                        <Button onClick={() => { }} className='mt-1 ms-1 current-plan' color='var(--primary)' background='var(--white)' borderColor='var(--primary)' fontWeight={'800'} uppercase primary text='your current plan' />

                        :
                        <Button onClick={() => switchPlan(plan.id, plan?.title ?? "")} className='mt-1 ms-1' color='var(--white)' background='var(--primary)' borderColor='var(--primary)' fontWeight={'800'} uppercase primary text='switch plan' />
                    }
                </div>
            </div>
        </div>
    )
}